import $ from 'jquery';

export default function () {

	$('a').not('.scrollTo').on('click touchend', function(e) {
	    var el = $(this);
	    var link = el.attr('href');
	    window.location = link;
	});
}